/**
 * Id d'un ticket Freshdesk à partir de ce que l'agent colle : le numéro seul
 * (« 27536 », « #27536 ») ou l'URL du ticket (.../a/tickets/27536).
 * Partagé par la modale SAV et le bloc « Partir d'un ticket » de la page clients.
 */
export const extractTicketId = (input) => {
  const raw = (input || "").trim();
  const fromUrl = raw.match(/\/tickets\/(\d+)/);
  if (fromUrl) return fromUrl[1];
  const digits = raw.match(/\d+/);
  return digits ? digits[0] : "";
};
